<div>
  <p class="text-secondary">{{'InstanceBrowser.DatesTitle' | translate}}</p>
  <div class="row">
    <div class="col-sm-3">
      <div class="form-group date-detail-centered">
        <label for="Country" class="date-detail-header">{{'InstanceBrowser.ManifestExpireDate' | translate}}</label>
        <p class="date-detail-value">{{getDateText(item.manifestExpireDate)}}&nbsp;</p>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group date-detail-centered">
        <label for="Country" class="date-detail-header">{{'InstanceBrowser.ManifestConfirmationDate' | translate}}</label>
        <p class="date-detail-value">{{getDateText(item.manifestConfirmationDate)}}&nbsp;</p>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group date-detail-centered">
        <label for="Country" class="date-detail-header">{{'InstanceBrowser.InstanceCreationDate' | translate}}</label>
        <p class="date-detail-value">{{getDateText(item.instanceCreationDate)}}&nbsp;</p>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group date-detail-centered">
        <label for="Country" class="date-detail-header">{{'InstanceBrowser.InstanceExpireDate' | translate}}</label>
        <p class="date-detail-value">{{getDateText(item.instanceExpireDate)}}&nbsp;</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-3">
      <div class="form-group date-detail-centered">
        <label for="Country" class="date-detail-header">{{'InstanceBrowser.SendToSubscriberDate' | translate}}</label>
        <p class="date-detail-value">{{getDateText(item.sendToSubscriberDate)}}&nbsp;</p>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group date-detail-centered">
        <label for="Country" class="date-detail-header">{{'InstanceBrowser.SendToRevisionDate' | translate}}</label>
        <p class="date-detail-value">{{getDateText(item.sendToRevisionDate)}}&nbsp;</p>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="form-group date-detail-centered">
        <label for="Country" class="date-detail-header">{{'InstanceBrowser.SubmitDate' | translate}}</label>
        <p class="date-detail-value">{{getDateText(item.submitDate)}}&nbsp;</p>
      </div>
    </div>
  </div>
  <br />
  <div *ngIf="item.sendToRevisionDate">
    <p class="text-secondary">{{'InstanceBrowser.Devolution' | translate}}</p>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label for="Country" class="date-detail-header">{{'InstanceBrowser.DevolutionTitle' | translate}}</label>
          <p class="date-detail-value">{{item.sendToRevisionReason}}&nbsp;</p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="item?.annulationMotive?.length > 0">
    <p class="text-secondary">{{'InstanceBrowser.AnnulationMotiveTitle' | translate}}</p>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label for="RejectionReason" class="date-detail-header">{{'InstanceBrowser.AnnulationMotiveTitle' | translate}}</label>
          <p class="date-detail-value">{{item.annulationMotive!='null'?item.annulationMotive:''}} {{item.annulationMotiveDescServ!='null'?item.annulationMotiveDescServ:''}}&nbsp;</p>
        </div>
      </div>
    </div>
  </div>
</div>
